/**
 * Public ticket pages are opened by attendees, not the team. They must not
 * offer to install OutreachOS: the app is for staff, and an attendee only
 * needs to show their ticket.
 */
export function isPublicTicketPath(pathname: string): boolean {
  return /^\/(t|ticket)\//.test(pathname)
}

/**
 * Pages someone sees before signing in. The app doesn't ask them to update
 * here: there's nothing of theirs to lose, and the question just gets in the
 * way of signing in. It asks on their first screen once they're signed in.
 */
export function isSignedOutPath(pathname: string): boolean {
  return /^\/(login|signup|forgot-password|reset-password)(\/|$)/.test(pathname)
}

/**
 * Makes a public ticket page not installable. Chrome only offers to install a
 * page that links a web app manifest, so the link is removed before Chrome
 * evaluates the page; any install prompt it still raises is suppressed.
 */
export function preventInstallOnPublicPages(doc: Document = document, win: Window = window): boolean {
  if (!isPublicTicketPath(win.location.pathname)) return false
  doc.querySelectorAll('link[rel="manifest"]').forEach((link) => link.remove())
  win.addEventListener('beforeinstallprompt', (event) => event.preventDefault())
  return true
}
